import WithRender from "../../templates/tables/informationTable.html";

export default WithRender({
  computed: {
    name: () => {
      return "Information";
    }
  }
});
